import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames } from '../../../models/Common';

const MembershipConfirmed = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = () => {
    history.push(GlobalRouteNames.HomePage);
  };

  return (
    <div className="success-container">
      <h1 className="skeleton--disabled">{t('success.balanceHasBeenReplenishedSuccessfully')}</h1>
      <p className="skeleton--disabled">{t('multiAccount.accountAdded')}</p>
      <CustomMUIButton
        label={t('buttons.toMain')}
        handleClick={handleClick}
        className={ButtonClassNames.PrimaryFulfilled}
        isBold
      />
    </div>
  );
};

export default MembershipConfirmed;
